module.exports = __webpack_public_path__ + "media/images/Pepsi Globe New-7c9beac189c8ec27654316d579c360f2.png";